import { render, staticRenderFns } from "./PopoverInfo.vue?vue&type=template&id=603e99dc&"
import script from "./PopoverInfo.vue?vue&type=script&lang=js&"
export * from "./PopoverInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports